import * as types from "../../actions/systemlevel/index";

export default function(state = null, action) {
  switch (action.type) {
    case types.FETCH_DEDUCTION_DELETE_ICON_CLICK_LIST:
      return action.payload;
    default:
      return state;
  }
}
